import axios from 'axios'
var hpConfig = require('./config.json') // 共通設定ファイル
let loaded
let categories = []

// const sleep = waitTime => new Promise(resolve => setTimeout(resolve, waitTime))

/*
async function getServies () {
  var i = 0
  hpConfig.category3_elment = []
  for (const cat of categories) {
    var ii = 0
    hpConfig.category3_elment[++i] = []
    await axios.get('https://stg.ranryu.co.jp/wp-json/wp/v2/service?service_cat=' + cat + '&order=asc').then(serviceResponse => {
      serviceResponse.data.forEach(service => {
        var srvObj = {'label': service.title.rendered, 'value': ++ii, 'checked': false}
        hpConfig.category3_elment[i][ii] = srvObj
      })
    }).catch(error => { alert(error) })
  }
}
*/
export default {
  methods: {
    getCategory: async function () {
      if (loaded) {
      } else {
        loaded = true
        await axios.get('https://stg.ranryu.co.jp/wp-json/wp/v2/service_cat?orderby=slug&order=asc').then(catResponse => {
          hpConfig.category2_elment = []
          var i = 0
          for (const cat in catResponse.data) {
            hpConfig.category2_elment.push({'label': catResponse.data[cat].name, 'value': ++i, 'show': false, 'catId': catResponse.data[cat].id})
            categories.push(catResponse.data[cat].id)
            /*
            var ii = 0
            axios.get('https://stg.ranryu.co.jp/wp-json/wp/v2/service?service_cat=' + catResponse.data[cat].id + '&order=asc').then(serviceResponse => {
              serviceResponse.data.forEach(service => {
                console.log(service.title.rendered)
                hpConfig.category3_elment.push({'label': service.title.rendered, 'value': ++ii, 'checked': false})
              })
            }).catch(error => { alert(error) })
            */
          }
        }).catch(error => { alert(error) })
      }
      return hpConfig
    },
    getServies: async function (cat) {
      // hpConfig.category3_elment = []
      /*
      var i = 0
      for (const cat of categories) {
        i++
      }
      */
      var services = await axios.get('https://stg.ranryu.co.jp/wp-json/wp/v2/service?service_cat=' + cat + '&order=asc').then(serviceResponse => {
        var ii = 0
        var tmp = []
        for (const service of serviceResponse.data) {
          var srvObj = {'label': service.title.rendered.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, ''), 'value': ii + 1, 'checked': false}
          // hpConfig.category3_elment[i].push(srvObj)
          tmp.push(srvObj)
          ii++
        }
        return tmp
      }).catch(error => { alert(error + ' happend') })
      // hpConfig.category3_elment.push( services )

      return services
    }
  },
  data () {
    return {
      hpConfig: hpConfig,
      contactIsFinish: false
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/index.js